class CollectionFilterMaster {
    constructor (theme, elem) {
        this.name = 'CollectionFilterMaster'
        this._theme = theme
        this._elem = elem
    }
    onInit () {
        const sortBy = this._elem.querySelectorAll('[data-sort-by]')
        if (sortBy.length > 0) {
            for (let sort of sortBy) {
                sort.addEventListener('change', (e) => { this.sortBy(e) })
            }
        }
        const open = this._elem.querySelector('[data-collection-mobile-open]')
        if (open) {
            open.addEventListener('click', () => { this.toggleDrawer() })
        }
        const apply = this._elem.querySelector('[data-apply-mobile]')
        if (apply) {
            apply.addEventListener('click', (e) => { e.preventDefault(); this.applyFilters() })
        }
        const reset = this._elem.querySelectorAll('[data-reset-global]')
        if (reset.length > 0) {
            for (let button of reset) {
                button.addEventListener('click', (e) => { e.preventDefault(); this.resetFilters() })
            }
        }
        const close = this._elem.querySelector('[data-collection-mobile-close]')
        if (close) {
            close.addEventListener('click', () => { this.closeDrawer() })
        }
        document.body.addEventListener('click', (e) => { this.checkOuterClick(e) })
    }

    openDrawer () {
        const drawer = this._elem.querySelector('[data-collection-mobile-drawer]')
        if (drawer) {
            drawer.classList.add('active')
            document.body.classList.add('no-scroll')
        }
    }
    closeDrawer () {
        const drawer = this._elem.querySelector('[data-collection-mobile-drawer]')
        if (drawer) {
            drawer.classList.remove('active')
            document.body.classList.remove('no-scroll')
        }
    }
    toggleDrawer () {
        const drawer = this._elem.querySelector('[data-collection-mobile-drawer]')
        if (drawer) {
            if (drawer.classList.contains('active')) {
                this.closeDrawer()
            } else {
                this.openDrawer()
            }
        }
    }

    applyFilters () {
        const filters = this._elem.querySelectorAll('[data-filter-option]')
        const root = this._elem.dataset.collectionFilterMaster
        if (filters.length > 0) {
            let filterURL = ''
            let index = 0
            for (var i = 0; i < filters.length; i++) {
                if (filters[i].checked) {
                    if (index > 0) { filterURL += '+' }
                    let value = filters[i].value.replace('.', '-')
                    value = value.replace('/', '-')
                    value = value.replace('\\', '-')
                    value = value.replace('#', '-')
                    value = value.replace('+', '-')
                    value = value.replace('?', '-')
                    value = value.replace('&', '-')
                    filterURL += `${value}`
                    index++
                }
            }
            const sortBy = this._elem.querySelector('[data-sort-by]')
            if (sortBy) {
                filterURL += `?sort_by=${sortBy.value}`
            }
            if (filterURL.length > 0) {
                window.location.href = `${root}/${filterURL}`
            } else {
                window.location.href = root
            }
        }
    }
    resetFilters () {
        const filters = this._elem.querySelectorAll('[data-filter-option]')
        if (filters.length > 0) {
            for (var i = 0; i < filters.length; i++) {
                if (filters[i].checked) {
                    filters[i].checked = ''
                }
            }
        }
        const sortBy = this._elem.querySelector('[data-sort-by]')
        if (sortBy) {
            sortBy.selectedIndex = 0
        }
        this.applyFilters()
    }
    checkOuterClick (e) {
        if (this._elem !== e.target && this._elem.contains(e.target)) {
        } else {
            this.closeDrawer()
        }
    }
    sortBy (e) {
        let value = e.currentTarget.value
        const sortBy = this._elem.querySelectorAll('[data-sort-by]')
        if (sortBy.length > 0) {
            for (let sort of sortBy) {
                sort.value = value
            }
        }
        this.applyFilters()
    }
}

export default CollectionFilterMaster



// WEBPACK FOOTER //
// ./src/resources/scripts/components/CollectionFilterMaster.js